import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
// import { derAutoCreateVirbom_terkk_klizac_children, derAutoCreateVirbom_terkk_klizac_prepare_vir_input, derivatPoluproizvod_klizac_naziv } from "./ter-derivat-lib-terkk-klizac";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
// PPGRUPA Klizač
U IZRADI

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_klizac = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_klizac.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_klizac',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR
    _subform_arr_subpp_klizactipa: [], // SUBFORM ARR
    _subform_arr_subpp_klizactipb: [], // SUBFORM ARR
    _subform_arr_subpp_klizactipbplitka: [], // SUBFORM ARR
    _subform_arr_subpp_klizactipc: [], // SUBFORM ARR
    _subform_arr_subpp_klizactipcplitka: [], // SUBFORM ARR
    /*
    _protobomp_subpp_klizactipa: protobomp_manipulator.init(),
    _protobomp_subpp_klizactipb: protobomp_manipulator.init(),
    _protobomp_subpp_klizactipbplitka: protobomp_manipulator.init(),
    _protobomp_subpp_klizactipc: protobomp_manipulator.init(),
    _protobomp_subpp_klizactipcplitka: protobomp_manipulator.init(),
    */
    // _protobomp: protobomp_manipulator.init("klizac"),
    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$klizac"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    klizac_brojelemenataiznadpanela: 0,
    klizac_brojelemenataiznadkadicestandardna: 0,
    klizac_brojelemenataiznadkadiceplitka: 0,
    klizac_kolikokadicastandardna: 0,
    klizac_kolikokadicaplitka: 0,

    kolicina: 1,
    klizac_kolikoa: 0,
    klizac_kolikob: 0,
    klizac_kolikob_levi: 0,
    klizac_kolikob_desni: 0,
    klizac_kolikobplitka: 0,
    klizac_kolikobplitka_levi: 0,
    klizac_kolikobplitka_desni: 0,
    klizac_kolikoc: 0,
    klizac_kolikocplitka: 0,

    klizactipa_materijal_lim: null,
    klizactipb_materijal_lim: null,
    klizactipc_materijal_lim: null,
    klizactipc_materijal_lim_plocica: null,
    klizactipc_materijal_profil: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_klizac.default_pods_input_state = () => {
  /*
  return {

  };
  */
  // return default_pods_input_state_smart_get('terkk$klizacprofil');
  return default_pods_input_state_smart_get('terkk$klizac');
};


draftel_codecs_pack_terkk$_bundle_klizac.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_klizac_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_klizac.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "vrstaprofila",
  // "msirinaspoljasnja",
  // "duzinamodula",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_klizac.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_klizac.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_klizac.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_klizac.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$klizac');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const klizacNaziv = '? Klizač ?';
  p.naziv = klizacNaziv;
  //
  const _params = {
    "operacija": "OPSKL",
    "rc": "RCDE",
    // tergrupa: 'klizac',
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$klizac',
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$klizac") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


draftel_codecs_pack_terkk$_bundle_klizac.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(_sf_item_raw => {
      let subDraftel_klizac = {
        ...draftel_codecs_pack_terkk$_bundle_klizac.default_preset_state(),
        ..._sf_item_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(subDraftel_klizac);
    });
  };
  return _unbundled_subDraftel_arr;
};


// NE KORISTI SE jer je ovaj draftel prebacen na protobomp koncept
/*
draftel_codecs_pack_terkk$_bundle_klizac.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$klizac');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  const paired_virtel = draftel_codecs_pack_terkk$_bundle_klizac.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  const _unbundled_subDraftel_arr = draftel_codecs_pack_terkk$_bundle_klizac.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);

  let pods_input_za_derivate = derAutoCreateVirbom_terkk_klizac_prepare_vir_input(paired_virtel); // ???
  let _der_virtel_children = derAutoCreateVirbom_terkk_klizac_children(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children klizac', _der_virtel_children);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};
*/


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

